import _objectSpread from"/home/circleci/repo/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";import _objectDestructuringEmpty from"/home/circleci/repo/node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty.js";import React from'react';// MUI
// import { styled } from '@mui/material/styles';
// import InputBase from '@mui/material/InputBase';
// ICONS
// import SearchIcon from '@mui/icons-material/Search';
import Search from'components/v2/FlexTable/Search';// const SearchIconWrapper = styled('div')(({ theme }) => ({
//   padding: theme.spacing(0, 2),
//   height: '100%',
//   position: 'absolute',
//   pointerEvents: 'none',
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'center',
// }));
// const SearchInputBase = styled(InputBase)(({ theme }) => ({
//   color: 'inherit',
//   '& .MuiInputBase-input': {
//     padding: theme.spacing(1, 1, 1, 0),
//     // vertical padding + font size from searchIcon
//     paddingLeft: `calc(1em + ${theme.spacing(4)})`,
//     transition: theme.transitions.create('width'),
//     width: '100%',
//   },
// }));
import{jsx as _jsx}from"react/jsx-runtime";var Index=function Index(_ref){var props=Object.assign({},(_objectDestructuringEmpty(_ref),_ref));// <SearchInputBase
//   placeholder="Search…"
//   inputProps={{ 'aria-label': 'search' }}
// />
// <SearchIconWrapper>
//   <SearchIcon />
// </SearchIconWrapper>
return/*#__PURE__*/_jsx(Search,_objectSpread({},props));};export default Index;